import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans notifications (clés `notifications.*` +
 * `nav.notifications.*`).
 *
 * Les clés vivent dans les fragments `features/notification/i18n/*.json`
 * et seront fusionnées dans `src/locales/*.json` lors du câblage final :
 * tant que la fusion n'est pas faite, `TFunctionType` (dérivé de `fr.json`)
 * ne les connaît pas encore, d'où le cast (pattern identique à
 * `use-transactions-translation.ts`).
 */
export const useNotificationsTranslation = () => {
  const { t } = useTypedTranslation();
  return {
    t: (key: string, params?: Record<string, unknown>) =>
      t(key as TFunctionType, params as Record<string, never>),
  };
};
